import React, { useState } from 'react';
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Checkbox,
  Box,
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';

const TreeItem = ({ 
  label, 
  children,
  checked,
  onCheck,
  nodeId,
  isParent = false,
  allChildrenChecked = false
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(!open);
  const handleCheck = (e) => {
    e.stopPropagation();
    onCheck(nodeId, e.target.checked);
  };

  return (
    <>
      <ListItemButton onClick={handleClick}>
        <Checkbox
          checked={isParent ? allChildrenChecked : checked}
          indeterminate={isParent && !allChildrenChecked && checked}
          onChange={handleCheck}
          onClick={(e) => e.stopPropagation()}
        />
        {children ? (open ? <ExpandLess /> : <ExpandMore />) : null}
        <ListItemText primary={label} />
      </ListItemButton>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            {children}
          </List>
        </Collapse>
      )}
    </>
  );
};

const CustomTreeView = ({ 
  items,
  checkedItems,
  onCheck
}) => {
  const isAllChildrenChecked = (node) => {
    if (!node.children) return false;
    return node.children.every(child => 
      checkedItems.includes(child.id) && 
      (child.children ? isAllChildrenChecked(child) : true)
    );
  };

  const renderTreeItems = (nodes) => {
    return nodes.map((node) => {
      const hasChildren = node.children && node.children.length > 0;
      return (
        <TreeItem
          key={node.id}
          nodeId={node.id}
          label={node.label}
          checked={checkedItems.includes(node.id)}
          onCheck={onCheck}
          isParent={hasChildren}
          allChildrenChecked={hasChildren && isAllChildrenChecked(node)}
        >
          {hasChildren && renderTreeItems(node.children)}
        </TreeItem>
      );
    });
  };

  return (
    <List>
      {renderTreeItems(items)}
    </List>
  );
};

export default CustomTreeView;
